import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from "@material-ui/core/Button";
import GenPdf from '../GenPdf';
import LoadingOverlay from "../LoadingOverlay";
import Header from '../Header/Header';
import NumDossFacAmendment from '../NumDossFacAmendment';
import DocMenu from "../DocMenu";
import YesNoDialog from '../YesNoDialog';
import InformationDialog from '../InformationDialog';
import FactureStatus from '../Factures/FactureStatus';
import FacAmendmentInfos from "./FacAmendment/FacAmendmentInfos";
import FacAmendmentTable from "./FacAmendment/FacAmendmentTable";
import { fetchFacAmendmentByDossIndex, changeFacAmendmentNumber } from "../../redux/actions/facAmendmentActions";
import { fetchContrat } from "../../redux/actions/contratActions";
import { changeTitleName, changePdfFileName } from "../../redux/actions/emailAction";
import { getDossier, getContactInfos, getContractAmendmentInfos, getNbFactures, getTauxhRea, titlesRealisation, ca, bred, genFacAmendment, getFacAmendment, getAmendmentLetter } from "./Utils";
import "../../Styles/FactureAmendment/FacAmendment.scss";

const FacAmendment = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    dossier: {},
    company: "",
    operation: "",
    adressOp: "",
    cpOp: "",
    cityOp: "",
    nameMo: "",
    sexeMo: "homme",
    adressMo: "",
    cityMo: "",
    cpMo: "",
    dates: [],
    numclient: "",
    bdcValue: "",
    dateEch: "",
    datecomptable: "",
    nfacture: "",
    bank: "",
    quantity: Array(9).fill(0),
    amountHt: Array(9).fill(0),
    nbHours: 0,
    totalht: 0,
    tauxh: 0,
    paymentMethod: 0,
    nbAmendments: 0,
    file: null,
    isFileOpen: false,
    tva: 20,
    disableButton: false,
    dataDetail: true,
    openDialog: false,
    openCreateFacDialog: false,
    isHidden: true,
  });

  const devisrea = useSelector(state => state.devis.devisrea);
  const dossierValue = useSelector(state => state.devis.dossierValue);
  const dossiers = useSelector(state => state.dossier.items);
  const contact = useSelector(state => state.contact.items);
  const contractFacAmendments = useSelector(state => state.facAmendment.contractFacAmendments);
  const facAmendmentsByDossIndex = useSelector(state => state.facAmendment.facAmendmentsByDossIndex);
  const facAmendmentIndex = useSelector(state => state.facAmendment.facAmendmentIndex);
  const contractFacAmendmentIndex = useSelector(state => state.facAmendment.contractFacAmendmentIndex);
  const infosContract = useSelector(state => state.contrat.items);

  const indexAmendmentLetter = getAmendmentLetter(contractFacAmendmentIndex);

  const checkIndex = useCallback((index) => {
    if (index < 4) return index - 1;
    if (index < 8) return index - 2;
    return index - 3;
  }, []);

  const generateArrayData = useCallback((quantity, amountHt) => {
    const { tauxh } = state;
    const result = [];
    for (let i = 0; i < quantity.length; i++) {
      result.push({
        title: titlesRealisation[i],
        quantity: quantity[i] === "" ? 0 : quantity[i],
        puht: tauxh.toFixed(2),
        amountht: amountHt[i].toFixed(2),
        tva: 1
      });
    }
    return result;
  }, [state.tauxh]);

  const transformText = useCallback((inputText) => {
    return inputText.replace(/(FR\s)(\d)(\d)(\d)/, '$1$2-$3-$4');
  }, []);

  const sumQuantity = useCallback((array) => {
    const arrayFormated = array.map(item => parseFloat(item === "" ? 0 : item));
    return parseFloat(arrayFormated.reduce((total, currentValue) => total + currentValue, 0).toFixed(4));
  }, []);

  const resetValues = useCallback(() => {
    setState(prev => ({
      ...prev,
      numclient: "",
      dateEch: "",
      nfacture: "",
      company: "",
      operation: "",
      adressOp: "",
      cpOp: "",
      cityOp: "",
      nameMo: "",
      sexeMo: "homme",
      adressMo: "",
      cityMo: "",
      cpMo: "",
      dates: [],
      tauxh: 0,
      nbHours: 0,
      paymentMethod: 0,
      bank: "",
      bdcValue: "",
      dataDetail: true,
      isHidden: true,
    }));
  }, []);

  const setNbFactures = useCallback(() => {
    setState(prev => ({
      ...prev,
      nbAmendments: getNbFactures(facAmendmentsByDossIndex, contractFacAmendmentIndex)
    }));
  }, [facAmendmentsByDossIndex, dossierValue, contractFacAmendmentIndex]);

  const loadData = useCallback(() => {
    setState(prev => ({ ...prev, disableButton: true }));
    dispatch(changePdfFileName(""));

    const currentFolder = getDossier(dossiers, dossierValue);
    const idcontact = currentFolder?.idcontact;
    const currentContact = idcontact !== null ? getContactInfos(contact, idcontact) : null;

    if (currentContact === null || !infosContract) {
      resetValues();
      setState(prev => ({ ...prev, disableButton: false }));
      return;
    }

    let currentContractAmendmentInfos = getContractAmendmentInfos(contractFacAmendments, dossierValue, contractFacAmendmentIndex);
    if (currentContractAmendmentInfos !== null) {
      currentContractAmendmentInfos.dates = currentContractAmendmentInfos.dates !== undefined ? JSON.parse(currentContractAmendmentInfos.dates) : [];
    }

    setState(prev => ({
      ...prev,
      dossier: currentFolder || {},
      numclient: facAmendmentsByDossIndex[facAmendmentIndex - 1]?.numclient || "",
      nfacture: facAmendmentsByDossIndex[facAmendmentIndex - 1]?.nfacture || "",
      datecomptable: facAmendmentsByDossIndex[facAmendmentIndex - 1] && facAmendmentsByDossIndex[facAmendmentIndex - 1].date_fac !== null
        ? new Date(facAmendmentsByDossIndex[facAmendmentIndex - 1].date_fac).toLocaleDateString("en-CA")
        : "",
      bdcValue: facAmendmentsByDossIndex[facAmendmentIndex - 1]?.bdc_facture || "",
      quantity: facAmendmentsByDossIndex[facAmendmentIndex - 1]
        ? JSON.parse(facAmendmentsByDossIndex[facAmendmentIndex - 1].quantity)
        : Array(9).fill(0),
      amountHt: facAmendmentsByDossIndex[facAmendmentIndex - 1]
        ? JSON.parse(facAmendmentsByDossIndex[facAmendmentIndex - 1].amount_ht)
        : Array(9).fill(0),
      totalht: facAmendmentsByDossIndex[facAmendmentIndex - 1]?.total_ht || 0,
      dateEch: currentContractAmendmentInfos?.dates?.[facAmendmentIndex - 1]?.dateech || "",
      nbHours: currentContractAmendmentInfos?.hours || 0,
      nameMo: `${currentContact.prenom || ''} ${currentContact.nom || ''}`,
      sexeMo: currentContact.sexe || "homme",
      adressMo: currentContact.adress || "",
      cityMo: currentContact.city || "",
      cpMo: currentContact.cp || "",
      company: currentFolder.sci_sccv || "",
      operation: currentFolder.operation || "",
      adressOp: currentFolder.adresse_op || "",
      cpOp: currentFolder.cp_op || "",
      cityOp: currentFolder.ville_op || "",
      bank: infosContract.bank || "",
      paymentMethod: currentContractAmendmentInfos?.payment_method || 0,
      dates: currentContractAmendmentInfos?.dates || [],
      tauxh: getTauxhRea(devisrea, dossierValue) || 0,
      dataDetail: facAmendmentsByDossIndex[facAmendmentIndex - 1] ? prev.dataDetail : true,
      isHidden: facAmendmentsByDossIndex[facAmendmentIndex - 1]
        ? facAmendmentsByDossIndex[facAmendmentIndex - 1].validation == 1 ? false : true
        : true,
      file: null,
      disableButton: false
    }));
  }, [
    dispatch,
    resetValues,
    dossiers,
    dossierValue,
    contact,
    infosContract,
    contractFacAmendments,
    contractFacAmendmentIndex,
    facAmendmentsByDossIndex,
    facAmendmentIndex,
    devisrea
  ]);

  const handleChange = ((event, index) => {
    const value = event.target.value;
    if (!/^[0-9.]*$/.test(value)) return;

    const elementHt = state.tauxh * value;
    let quantity = [...state.quantity];
    let amountHt = [...state.amountHt];
    quantity[checkIndex(index)] = value;
    amountHt[checkIndex(index)] = parseFloat(elementHt.toFixed(4));

    const totalht = parseFloat(quantity.reduce((total, qtt) => total + (qtt * state.tauxh || 0), 0).toFixed(2));

    setState(prev => ({ ...prev, quantity, amountHt, totalht }));
  });

  const handleChangeValues = useCallback((event) => {
    const { name, value } = event.target;
    setState(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleChangeTva = useCallback((value) => {
    setState(prev => ({ ...prev, tva: value }));
  }, []);

  const handleButtonClick = useCallback((isDataDetail) => {
    setState(prev => ({ ...prev, dataDetail: isDataDetail }));
  }, []);

  const hundleCreateFacAmendment = useCallback(async () => {
    const { bank, tva, dates, tauxh, paymentMethod, nbAmendments, dossier, nbHours } = state;
    const daysCount = dates.length * 5 || 1;
    const quantityItem = parseFloat((nbHours / daysCount).toFixed(4));
    const amountHtItem = parseFloat((quantityItem * tauxh).toFixed(2));
    const total = (nbHours * tauxh) / dates.length || 0;
    const quantityItems = [quantityItem, quantityItem, quantityItem, quantityItem, 0, quantityItem, 0, 0, 0];
    const amountHtItems = [amountHtItem, amountHtItem, amountHtItem, amountHtItem, 0, amountHtItem, 0, 0, 0];

    setState(prev => ({ ...prev, disableButton: true }));

    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          ndossier: dossierValue,
          amendment_number: contractFacAmendmentIndex,
          cp_op: dossier.cp_op,
          date_ech: dates[facAmendmentIndex]?.dateech,
          quantity: JSON.stringify(quantityItems),
          amount_ht: JSON.stringify(amountHtItems),
          total_ht: total,
          tva,
          pu_ht: tauxh,
          bank,
          payment_method: paymentMethod,
        })
      };

      const response = await fetch("/api/facamendment/createFacAmendment", requestOptions);
      if (!response.ok) throw new Error("La requête a échoué.");

      await dispatch(fetchFacAmendmentByDossIndex(dossierValue, contractFacAmendmentIndex));
      await dispatch(changeFacAmendmentNumber(nbAmendments + 1));
      await setNbFactures();
    } catch (error) {
      console.error("Erreur lors de la création de la facture :", error);
    } finally {
      setState(prev => ({ ...prev, disableButton: false, openCreateFacDialog: false }));
    }
  }, [state, dossierValue, contractFacAmendmentIndex, facAmendmentIndex, dispatch]);

  const handleSaveClick = useCallback(async () => {
    setState(prev => ({ ...prev, disableButton: true }));
    const { numclient, bdcValue, dateEch, datecomptable, quantity, amountHt, bank, tva, tauxh, paymentMethod } = state;

    if (!datecomptable) {
      setState(prev => ({ ...prev, disableButton: false, openDialog: true }));
      return;
    }

    const quantityParseFloat = quantity.map(item => parseFloat(item === "" ? 0 : item));

    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          ndossier: dossierValue,
          amendment_number: contractFacAmendmentIndex,
          numclient,
          bdc_facture: bdcValue,
          date_ech: dateEch,
          date_fac: datecomptable,
          quantity: JSON.stringify(quantityParseFloat),
          amount_ht: JSON.stringify(amountHt),
          total_ht: parseFloat(quantity.reduce((total, qtt) => total + (qtt * tauxh || 0), 0).toFixed(2)),
          tva,
          pu_ht: tauxh,
          bank,
          payment_method: paymentMethod,
        })
      };

      const response = await fetch("/api/facamendment/updateFacAmendment", requestOptions);
      if (!response.ok) throw new Error("La requête a échoué.");

      await dispatch(fetchFacAmendmentByDossIndex(dossierValue, contractFacAmendmentIndex));
      await dispatch(changeFacAmendmentNumber(facAmendmentIndex));
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la facture :", error);
    } finally {
      setState(prev => ({ ...prev, disableButton: false }));
    }
  }, [state, dossierValue, contractFacAmendmentIndex, facAmendmentIndex, dispatch]);

  const handleGenClick = useCallback(async () => {
    const { numclient, nfacture, nameMo, sexeMo, bdcValue, totalht, tva, quantity, amountHt, dossier, datecomptable, tauxh } = state;

    if (!datecomptable) {
      setState(prev => ({ ...prev, openDialog: true }));
      return;
    }

    setState(prev => ({ ...prev, file: null, disableButton: true }));

    const arraydata = generateArrayData(quantity, amountHt);
    const amouttva = totalht * tva / 100;
    const totalttc = totalht + amouttva;
    const totalhtFixed = parseFloat(quantity.reduce((total, qtt) => total + (qtt * tauxh || 0), 0).toFixed(2));

    const nfacvalue = nfacture.replace(' ', `/${indexAmendmentLetter}-`);
    const customerCode = transformText(numclient);
    const sumquantity = sumQuantity(quantity);
    const bank_name = state.bank;
    const bank = state.bank == 'ca' ? ca : bred;
    const mo = {
      name: sexeMo == 'homme' ? `Monsieur ${nameMo}` : `Madame ${nameMo}`,
      adress: state.adressMo,
      cp: state.cpMo,
      city: state.cityMo
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        ndossier: dossierValue,
        contractIndex: contractFacAmendmentIndex,
        filetitle: customerCode.replace(/\//g, ' '),
        customercode: customerCode,
        dossier,
        arraydata,
        tva,
        amouttva,
        totalht: totalhtFixed,
        totalttc,
        sumquantity,
        bank_name,
        bank,
        nfacvalue,
        mo,
        datefac: state.dateEch,
        datecompta: datecomptable,
        facture_type: 'rea',
        bdc_facture: bdcValue
      })
    };

    const blob = await genFacAmendment(requestOptions);
    if (blob) {
      setState(prev => ({ ...prev, file: blob, isFileOpen: true }));
    }
    setState(prev => ({ ...prev, disableButton: false }));
  }, [state, dossierValue, contractFacAmendmentIndex, generateArrayData, transformText, sumQuantity]);

  const handleShowPdf = useCallback(async () => {
    const customerCode = state.numclient.replace(/\//g, ' ').split(' ')[2];
    setState(prev => ({ ...prev, file: null, disableButton: true }));

    const response = await getFacAmendment(dossierValue, customerCode, contractFacAmendmentIndex, 'pdf');
    if (response.blob.size > 100) {
      setState(prev => ({ ...prev, file: response.blob, isFileOpen: true }));
      dispatch(changePdfFileName(response.fileName));
    }
    setState(prev => ({ ...prev, disableButton: false }));
  }, [state.numclient, dossierValue, dispatch]);

  const handleGetPdfFile = useCallback(async () => {
    const customerCode = state.numclient.replace(/\//g, ' ').split(' ')[2];
    setState(prev => ({ ...prev, file: null }));

    const response = await getFacAmendment(dossierValue, customerCode, contractFacAmendmentIndex, 'pdf');
    if (response.blob.size > 100) {
      setState(prev => ({ ...prev, file: response.blob }));
      dispatch(changePdfFileName(response.fileName));
    }
  }, [state.numclient, dossierValue, dispatch]);

  const handleGetWordFile = useCallback(async () => {
    const customerCode = state.numclient.replace(/\//g, ' ').split(' ')[2];
    setState(prev => ({ ...prev, file: null }));

    const response = await getFacAmendment(dossierValue, customerCode, contractFacAmendmentIndex, 'word');
    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setState(prev => ({ ...prev, file: response.blob }));
      dispatch(changePdfFileName(response.fileName));
    }
  }, [state.numclient, dossierValue, dispatch]);

  const closeDoc = useCallback(() => {
    setState(prev => ({ ...prev, isFileOpen: false }));
  }, []);

  const handleClose = useCallback(() => {
    setState(prev => ({ ...prev, openDialog: false }));
  }, []);

  const handleOpenCreateFac = useCallback(() => {
    setState(prev => ({ ...prev, openCreateFacDialog: true }));
  }, []);

  const handleCloseCreateFac = useCallback(() => {
    setState(prev => ({ ...prev, openCreateFacDialog: false }));
  }, []);

  const handleChangeTitleName = useCallback(() => {
    dispatch(changeTitleName(`Facture Avenant ${indexAmendmentLetter}R${facAmendmentIndex}`));
  }, [dispatch, facAmendmentIndex]);

  useEffect(() => {
    const fetchContratData = async () => {
      if (!dossierValue) return;
      await dispatch(fetchContrat(dossierValue));
    };

    fetchContratData();
  }, [dossierValue]);

  useEffect(() => {
    loadData();
    setNbFactures();
  }, [
    devisrea,
    dossiers,
    contact,
    infosContract,
    contractFacAmendments,
    facAmendmentsByDossIndex,
    dossierValue,
    facAmendmentIndex,
    contractFacAmendmentIndex
  ]);

  const { dataDetail, dates, openDialog, openCreateFacDialog, isHidden, dateEch, nbAmendments, file, disableButton } = state;
  return (
    <div className="fac-amendment">
      {disableButton && <LoadingOverlay />}
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
      />
      <NumDossFacAmendment type="facAmendment" />
      <h1 className="title">Facture Avenant</h1>
      <FactureStatus isHidden={isHidden} dateFacture={dateEch} type="realisation" />
      <div className="data">
        <div className="btns">
          <Button
            className="btn"
            variant="contained"
            style={{
              color: dataDetail ? "black" : "white",
              fontWeight: dataDetail ? "bold" : "",
              backgroundColor: dataDetail ? "rgb(253, 181, 142)" : "rgba(255, 127, 80, 0.73)",
            }}
            onClick={() => handleButtonClick(true)}
          >
            Données
          </Button>
          <Button
            className="btn"
            variant="contained"
            style={{
              color: !dataDetail ? "black" : "white",
              fontWeight: !dataDetail ? "bold" : "",
              backgroundColor: !dataDetail ? "rgb(253, 181, 142)" : "rgba(255, 127, 80, 0.73)",
              ...(facAmendmentIndex === 0 ? { backgroundColor: "#ccc", cursor: "not-allowed" } : {}),
            }}
            onClick={() => handleButtonClick(false)}
            disabled={facAmendmentIndex === 0}
          >
            Détails
          </Button>
        </div>

        {dataDetail ? (
          <FacAmendmentInfos
            numclient={state.numclient}
            company={state.company}
            nameMo={state.nameMo}
            operation={state.operation}
            adressOp={state.adressOp}
            cpOp={state.cpOp}
            cityOp={state.cityOp}
            tauxh={state.tauxh}
            nbHours={state.nbHours}
            paymentMethod={state.paymentMethod}
            nbAmendments={nbAmendments}
            dates={dates}
            dateEch={state.dateEch}
            datecomptable={state.datecomptable}
            bdcValue={state.bdcValue}
            handleChangeValues={handleChangeValues}
            hundleCreateFacAmendment={handleOpenCreateFac}
          />
        ) : (
          <FacAmendmentTable
            quantity={state.quantity}
            amountHt={state.amountHt}
            totalht={state.totalht}
            tva={state.tva}
            puHt={state.tauxh}
            disableButton={state.disableButton}
            checkIndex={checkIndex}
            handleChangeTva={handleChangeTva}
            handleChange={handleChange}
            handleSaveClick={handleSaveClick}
            handleGenClick={handleGenClick}
            handleShowPdf={handleShowPdf}
            loadData={loadData}
          />
        )}

        <InformationDialog
          isOpen={openDialog}
          title="INFORMATION"
          information="La date de comptabilité (facturation) n'est pas communiquée"
          handleClose={handleClose}
        />
        <YesNoDialog
          isOpen={openCreateFacDialog}
          title="CRÉATION FACTURE AVENANT"
          question={`Voulez-vous créer la facture avenant «${indexAmendmentLetter}R${nbAmendments + 1}» du dossier «${dossierValue}» ?`}
          handleYesClick={hundleCreateFacAmendment}
          handleClose={handleCloseCreateFac}
        />
        <GenPdf
          isOpen={state.isFileOpen}
          file={file}
          closeDoc={closeDoc}
          scale={file !== null ? 1 : 0.5}
        />
      </div>
    </div>
  );
};

export default FacAmendment;